import bus from "./bus";
import config from "./config";
import * as echarts from "echarts"; //使用echart5 2021.10.21
// import echarts from "echarts";
import { formatDate } from "./parseTime";
function fungetdate(count) {
  var dd = new Date();
  dd.setDate(dd.getDate() + count); //获取p_count天后的日期
  return dd;
}
const custom = {
  bus,
  formatDate,
  fungetdate,
  config,
  echarts
};

export default custom;
